<template>
    <div class="view" :style="{paddingTop:barh(100)}">
        <div class="content">
            <my-top title="我发起的" lefttext="返回"></my-top>
            <div class="screenbox" :style="{top:navbarheight}">
                <tabs v-model="active" class="sarchtabs" @change="clicktabs">
                    <tab :badge="item.id=='toRead' && toReadCount" v-for="item in approvallist" :title="item.name" :name="item.id" :key="item.id">
                      <mattersList :active="active"></mattersList>
                    </tab>
                </tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import {Tab, Tabs} from 'vant';
    import mattersList from './list.vue'

    export default {
        name:'matters',
        components: {
          mattersList,
          Tabs,
          Tab
        },
        data() {
            return {
                // active: 'toRead',
                approvallist: [
                    {name:'未结束',id:'toRead'},
                    {name:'已结束',id:'isRead'}
                ],
            }
        },
        created(){
            // if (this.$store.state.project.key === 0) {
            //
            // }  else if (this.$store.state.project.key === 1){
            //
            // }
        },
        computed: {
          active() {
            return this.$route.query.active || 'toRead'
          },
          toReadCount() {
            let count = Number(this.$store.getters['messageInfo/GET_TOMYCOUNT'])
            if (isNaN(count) || count == 0) {
              return null
            }
            return count > 99 ? '99+' : count
          }
        },
        methods: {
            clicktabs(name, title) {
              // console.log(name)
              this.$router.replace({
                path: '/application/myMessages',
                query: {
                  key:1, 
                  active: name
                }
              })
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .view {
        .content {
            padding-bottom: 50px;
            .screenbox {
                width: 100%;
                position: fixed;
                left: 0;
                z-index: 2;
                .sarch {
                    ::v-deep .van-search {
                        .van-search__content {
                            border-radius: 20px;
                        }
                    }
                }
                .sarchtabs {
                    ::v-deep .van-tabs__line {
                        background-color: #018fe0;
                        bottom: 18px;
                    }
                }
            }
        }
    }

</style>
